package one.healthium.healthKit.ui

import androidx.compose.runtime.Composable

@Composable
actual fun ConnectFlowContainer(
    action: ConnectFlowAction,
    content: @Composable ((ConnectFlowController) -> Unit)
) {
}